import EcosystemSettingsPanel from '../../../components/EcosystemSettingsPanel';
import type { MainPanelProps } from '@frontend/pages/dashboard/types';
import SystemAdminPage from '../admin/SystemAdminPage';
import RealmAdminPage from '../admin/RealmAdminPage';
import EcosystemAdminPage from '../admin/EcosystemAdminPage';
import ProjectAdminPage from '../admin/ProjectAdminPage';
import FeedbackDetail from './components/FeedbackDetail';
import EcosystemDetail from './components/EcosystemDetail';
import ProjectDetail from './components/ProjectDetail';
import MainPanelTopbar from './components/MainPanelTopbar';

const ADMIN_KINDS = new Set([
	'admin-system',
	'admin-realm',
	'admin-ecosystem',
	'admin-project',
]);

export default function MainPanel({
	user,
	projectAdminEligible = false,
	selected,
	ecosystemDefs,
	projectsByEcosystem,
	overview,
	onGoHome,
	onSelectProject,
}: MainPanelProps) {
	const selectedProject =
		selected.kind === 'project'
			? (projectsByEcosystem[selected.ecosystemId] || []).find(
					(item) => item.id === selected.projectId
				) || null
			: null;

	const selectedOverview =
		selected.kind === 'project' || selected.kind === 'ecosystem'
			? overview?.ecosystems?.[selected.ecosystemId] || null
			: null;

	const showTopbar =
		ADMIN_KINDS.has(selected.kind) || selected.kind === 'ecosystem-settings';

	return (
		<main className="tree-dashboard-main ecosystem-card">
			{showTopbar ? <MainPanelTopbar onGoHome={onGoHome} /> : null}
			{selected.kind === 'feedback' ? <FeedbackDetail /> : null}
			{selected.kind === 'ecosystem' ? (
				<EcosystemDetail
					ecosystemId={selected.ecosystemId}
					ecosystemDefs={ecosystemDefs}
					projects={projectsByEcosystem[selected.ecosystemId] || []}
					selectedOverview={selectedOverview}
					onSelectProject={onSelectProject}
				/>
			) : null}
			{selected.kind === 'project' && selectedProject ? (
				<ProjectDetail
					selectedProject={selectedProject}
					ecosystemId={selected.ecosystemId}
					ecosystemDefs={ecosystemDefs}
					overviewForEco={overview?.ecosystems?.[selected.ecosystemId] || null}
				/>
			) : null}
			{selected.kind === 'ecosystem-settings' ? <EcosystemSettingsPanel user={user} /> : null}
			{selected.kind === 'admin-system' ? <SystemAdminPage user={user} /> : null}
			{selected.kind === 'admin-realm' ? <RealmAdminPage user={user} /> : null}
			{selected.kind === 'admin-ecosystem' ? <EcosystemAdminPage user={user} /> : null}
			{selected.kind === 'admin-project' ? (
				<ProjectAdminPage user={user} allowMaintainerAccess={projectAdminEligible} />
			) : null}
		</main>
	);
}
